import axios from 'axios';
import { Col, Row } from 'antd';
import { BASE_API } from '../../axios';
import { Document, Page, pdfjs } from 'react-pdf';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  calculateExactAge,
  getAccessToken,
  getUserDetails,
  makePostCall,
  makeGetCall,
} from '../../utils/helper';
import './view-notes.scss';
import PdfViewer from '../../components/PdfViewer';
import { FieldLabels } from '../../constants/fieldLabels';
const moment = require('moment');

const ViewNotes = ({ viewNotesModal, handleNoteSelection, selectedNote }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf-worker-min.js';
  const [prevNotes, setPrevNotes] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [mimeType, setMimeType] = useState('');

  const { details } = viewNotesModal;
  const { pacs_order } = details;
  const { patient } = pacs_order;

  const ALLOWED_FILE_TYPES = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
  };

  const customHeaders = {
    Authorization: `Bearer ${getAccessToken()}`, // Add your token here
  };

  const user_id = getUserDetails()?.username;

  useEffect(() => {
    fetchPrevNotes();
  }, []);

  useEffect(() => {
    const mtype = selectedNote?.rn_upload_path?.split('.').pop();

    const mymime = ALLOWED_FILE_TYPES[mtype];
    console.log('mimetype', mymime);
    setMimeType(mymime);

    if (selectedNote?.rn_upload_path && selectedNote?.rn_upload_type !== 'notes') {
      fetchDocumentContent();
    } else {
      setPdfData(null);
    }
  }, [selectedNote]);

  const fetchDocumentContent = async () => {
    setLoadingPdf(true);
    try {
      makeGetCall(`/fetch-note-file-by-id?note_id=${selectedNote.rn_id}`, {
        headers: customHeaders,
        responseType: 'arraybuffer',
      })
        .then(res => {
          setPdfData(res.data);
          console.log('PDF Data:', res.data);
        })
        .catch(e => {
          console.log('Error', e);
        });
    } catch (error) {
      console.error('Error loading PDF', error);
      setPdfData(null);
    } finally {
      setLoadingPdf(false);
    }
  };

  const fetchPrevNotes = () => {
    const { pacs_order } = viewNotesModal?.details;
    const { patient } = pacs_order;
    const { pat_pin } = patient;

    const payload = {
      user_id,
      pin: pat_pin,
      order_id: pacs_order.his_ord_no,
      ord_no: pacs_order.pacs_ord_id,
    };

    // get specific note if note_id is present
    if (viewNotesModal?.details?.note_id) {
      const npayload = {
        note_id: viewNotesModal?.details?.note_id,
      };

      makePostCall('/fetch-note-by-id', npayload)
        .then(res => {
          handleNoteSelection(res.data?.data, viewNotesModal?.details);
          console.log('Selected Note ', selectedNote);
        })
        .catch(e => {
          console.log('Error', e);
          handleNoteSelection(null, viewNotesModal?.details);
        });
    }

    makePostCall('/pat-prev-notes', payload)
      .then(res => {
        console.log('npayload', payload, res);
        setPrevNotes(res.data?.data || []);
        console.log('note_id', res.data?.data);
      })
      .catch(e => {
        console.log('Error', e);
        setPrevNotes([]);
      });
  };

  return (
    <div className="view-notes-container">
      <div className="notes-header">RIS NOTES</div>
      <div>
        <div style={{ width: '1200px' }}>
          <Row>
            <Col span={8}>
              <span className="notes-label">{FieldLabels.PATIENT_NAME}: </span>
              <span className="notes-value">{patient?.pat_name}</span>
            </Col>
            <Col span={8}>
              <span className="notes-label">{FieldLabels.PATIENT_ID}: </span>
              <span className="notes-value">{patient?.pat_pin}</span>
            </Col>
            <Col span={8}>
              <span className="notes-label">{FieldLabels.PATIENT_REPORT_AGE}: </span>
              <span className="notes-value">{calculateExactAge(patient?.pat_dob)}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span className="notes-label">Order No: </span>
              <span className="notes-value">{pacs_order?.po_his_ord_no}</span>
            </Col>
            <Col span={8}>
              <span className="notes-label">Accession No: </span>
              <span className="notes-value">{pacs_order?.po_acc_no}</span>
            </Col>
            <Col span={8}>
              <span className="notes-label">{FieldLabels.REFERRING_PHYSICIAN} </span>
              <span className="notes-value">{pacs_order?.po_ref_doc}</span>
            </Col>
          </Row>
        </div>
      </div>
      <Row className="mt-3">
        <Col span={8}>
          <div className="notes-list">
            {prevNotes?.map(dateNote => (
              <div key={dateNote.creationdate}>
                <div className="notes-date">{dateNote.creationdate}</div>
                {dateNote?.rows?.map(note => (
                  <div
                    key={note.rn_id}
                    className={`notes-list-item ${note.rn_id === selectedNote?.rn_id ? 'selected' : ''}`}
                    onClick={() => {
                      handleNoteSelection(note, viewNotesModal?.details);
                    }}
                  >
                    {`${note.rn_upload_type?.toUpperCase()} ${note.rn_file_name ? ' | ' + note.rn_file_name : ''} | ${moment(note.createdAt).format('DD/MM/YYYY HH:mm:ss') || ''}`}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Col>
        <Col span={16}>
          <div
            className="notes-detail"
            style={{ height: '425px', overflowY: 'auto' }}
          >
            {selectedNote?.rn_upload_type === 'notes' ? (
              <div style={{ padding: '5px' }}>{selectedNote?.rn_notes}</div>
            ) : (
              selectedNote?.rn_upload_path && (
                <PdfViewer
                  pdfArrayBuffer={pdfData}
                  refreshing={loadingPdf}
                  patient_id={patient?.pat_id}
                  order_id={pacs_order?.pacs_ord_id}
                  patientData={{
                    patient: patient,
                    ps_study_dt_tm: selectedNote?.createdAt,
                  }}
                  onReportUpdated
                  hideCopyButton={true}
                  hideWhatsappButton={true}
                  mimeType={mimeType}
                />
              )
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ViewNotes;
